// The v2 partial-import endpoint only echoes created paddocks on success (atomic batch — see
// spec: farm-subdivision-partial-import, Overlap Resolution Threshold). Auto-skipped
// near-duplicates (>=90% IoU) are silently dropped server-side with no dedicated list, so the
// only way to surface skip feedback to the user is diffing the client-parsed KML feature names
// against the names the server actually created.
export const summarizePartialImport = ({
  importedFeatureNames,
  paddocksCreated,
}: {
  importedFeatureNames: string[]
  paddocksCreated: { name: string }[]
}): { skippedNames: string[] } => {
  const createdNames = paddocksCreated.map(paddock => paddock.name)

  // Occurrences, not set membership: a near-duplicate is by definition the feature most likely to
  // repeat a name already created, so matching by name alone would hide exactly the skips we want
  // to surface. Each created paddock can only account for one imported feature of that name.
  const unmatchedCreatedByName = new Map<string, number>()
  createdNames.forEach(name => {
    unmatchedCreatedByName.set(name, (unmatchedCreatedByName.get(name) ?? 0) + 1)
  })

  const skippedNames = importedFeatureNames.filter(name => {
    const unmatched = unmatchedCreatedByName.get(name) ?? 0
    if (unmatched === 0) return true
    unmatchedCreatedByName.set(name, unmatched - 1)
    return false
  })

  return { skippedNames }
}
